export enum ProgressStatus {
    PreRun, Current, Resulting, PostRun
}

export class PeriodProgressState {

    progressStatus: ProgressStatus;
    periodRelativeProgressInMilli: number;
    relativePercentProgress: number;

    constructor(source: PeriodProgressState) {
        this.progressStatus = source.progressStatus;
        this.periodRelativeProgressInMilli = source.periodRelativeProgressInMilli;
        this.relativePercentProgress = source.relativePercentProgress;
    }

}